export const TogglePassword = {
    data() {
        return {
            isHidePw: true,
            classEyeIcon: "fa-eye-slash",
            typePassword: "password",
            isHidePwCf: true,
            classEyeIconCf: "fa-eye-slash",
            typePasswordCf: "password",
        }
    },
    methods: {
        togglePassword() {
            this.isHidePw = !this.isHidePw
            if (this.isHidePw) {
                this.classEyeIcon = "fa-eye-slash",
                this.typePassword = "password"
            } else {
                this.classEyeIcon = "fa-eye",
                this.typePassword = "text"
            }
        },
        togglePasswordCf() {
            this.isHidePwCf = !this.isHidePwCf
            if (this.isHidePwCf) {
                this.classEyeIconCf = "fa-eye-slash"
                this.typePasswordCf = "password"
            } else {
                this.classEyeIconCf = "fa-eye"
                this.typePasswordCf = "text"
            }
        },
    }
}
